import { render, staticRenderFns } from "./OutdatedError.vue?vue&type=template&id=753904a2&scoped=true&lang=pug&"
import script from "./OutdatedError.vue?vue&type=script&lang=js&"
export * from "./OutdatedError.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedError.vue?vue&type=style&index=0&id=753904a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753904a2",
  null
  
)

export default component.exports